<template>
    <div>
        <b-card class="shadow mb-5 ml-md-5 mr-md-5 ml-0 mr-0" v-if="!stub">

            <div class="d-flex flex-column flex-xl-row w-100 align-items-start justify-content-start mb-5">

                <div class="d-flex flex-grow-1 align-items-xl-center mb-4 mb-xl-0 flex-column flex-sm-row w-100">
                    <b-button
                            variant="link"
                            class="flex-grow-0 d-flex align-items-center text-secondary flex-nowrap p-0 mb-4"
                            @click="back()">
                        <b-icon icon="chevron-left" class="mr-2"/>
                        <span>Назад</span>
                    </b-button>

                    <div class="d-flex flex-column w-100">
                        <div class="d-flex flex-grow-1 align-items-baseline justify-content-center flex-column flex-sm-row mb-3"
                             :key="objectKey + '-header'">
                            <span class="h3 mb-2 mb-lg-0" v-if="!object.id">
                                <span>Информационный материал</span>
                            </span>
                            <span class="h3 mb-2 mb-lg-0 mr-3" v-else>{{ header }}</span>
                            <sup><small v-if="!object.id" class="text-secondary ml-2">Новый</small></sup>
                        </div>
                    </div>

                </div>

            </div>


            <div id="questionForm">

                <b-form-row>

                  <form-field :label="getFieldLabel('group')"
                              class="col-xs-12 col-lg-6 required m-2"
                              :editable="getAbility('group')"
                              :feedback="liveFeedback('group')"
                              :value="object.group"
                              :key="objectKey + '-group'">
                      <template #field>
                          <div class="d-flex">
                              <single-select name="group"
                                             class="flex-grow-1"
                                     v-model="form['groupObject']"
                                     :url="groupsUrl"
                                     :label="getFieldLabel('group')"
                                     :state="getValidationClass('group')"
                                     v-on:select-changed="onModelObjectSingleSelectChanged"
                                     v-on:select-cleared="onModelObjectSingleSelectCleared" />
                          </div>
                      </template>
                  </form-field>

                  <form-field class="col-xs-12 col-lg-4 m-2 pt-1"
                              :editable="true"
                              :key="objectKey + '-group-button'">
                      <template #field>
                            <b-button class="flex-grow-0 mt-3" @click="showAddGroupModal" v-if="canCreateGroups">
                                <b-icon icon="plus" />
                                <span>Добавить тематику</span>
                            </b-button>
                      </template>
                  </form-field>


                    <form-field
                                 class="col-xs-12 col-lg-6 required m-2"
                                 :label="getFieldLabel('text')"
                                 :editable="getAbility('text')"
                                 :value="object.text"
                                 :feedback="liveFeedback('text')">
                        <template #field>
                            <b-form-input
                                id="text"
                                class="w-100"
                                type="text"
                                v-model="$v.form.text.$model"
                                :state="validateState('text')">
                            </b-form-input>
                        </template>
                    </form-field>


                  <form-field class="col-12 col-sm-6 col-md-4 col-lg-2 col-xl-1 required m-2"
                               :label="getFieldLabel('listOrder')"
                               :editable="getAbility('listOrder')"
                               :value="getObjectField('listOrder')"
                               :feedback="liveFeedback('listOrder')">
                      <template #field>
                          <b-form-input
                              id="listOrder"
                              class="w-100"
                              type="number"
                              v-model="$v.form.listOrder.$model"
                              :state="validateState('listOrder')">
                          </b-form-input>
                      </template>
                  </form-field>

                    <form-field
                                 class="col-xs-12 col-lg-6 required m-2"
                                 :label="getFieldLabel('answer')"
                                 :editable="getAbility('answer')"
                                 :value="object.answer"
                                 :feedback="liveFeedback('answer')">
                        <template #field>
<!--                            <b-textarea-->
<!--                                id="answer"-->
<!--                                class="w-100"-->
<!--                                rows="5"-->
<!--                                v-model="$v.form.answer.$model"-->
<!--                                :state="validateState('answer')">-->
<!--                            </b-textarea>-->
                            <vue-editor v-model="$v.form.answer.$model" :editorToolbar="editorToolbar" @text-change="onTextChange"/>
                        </template>
                    </form-field>

                    <form-field :label="getFieldLabel('publish')"
                            class="col-xs-12 col-sm-8 col-md-4 col-lg-3 m-2"
                            :value="object.publish"
                            :editable="getAbility('publish')"
                            :feedback="liveFeedback('publish')">
                    <template #field>
                        <b-form-checkbox  size="lg" v-model="form.publish" @change="onPublishChange" switch >
                            <span v-if="form.publish">Да</span>
                            <span v-else>Нет</span>
                        </b-form-checkbox>

                    </template>
                </form-field>

                </b-form-row>

                <b-form-row class="">
                    <gallery :label="'Фото'"
                             :root-api-url="attachmentsUrl"
                             :can-update="hasAbilityToUpdateAttachments"
                             :max-files="5"
                             :accepts="photoGalleryAccepts"
                             :upload-immediately="true"
                             :max-size="20"
                             :kind="1"
                             :existing="Boolean(objectId)"
                             :delete-on-remove="false"
                             @files-uploaded="onFilesUploaded($event, 1)"
                             @files-removed="onFilesRemoved($event, 1)"
                             ref="photoGallery"
                             class="col-xs-12 col-sm-12 col-lg-6 m-2">
                    </gallery>

                    <gallery :label="'Видео'"
                             :root-api-url="attachmentsUrl"
                             :can-update="hasAbilityToUpdateAttachments"
                             :max-files="4"
                             :accepts="videoGalleryAccepts"
                             :upload-immediately="true"
                             :max-size="10"
                             :kind="3"
                             :existing="Boolean(objectId)"
                             :delete-on-remove="false"
                             @files-uploaded="onFilesUploaded($event, 3)"
                             @files-removed="onFilesRemoved($event, 3)"
                             ref="videoGallery"
                             class="col-xs-12 col-sm-12 col-lg-6 m-2">
                    </gallery>

                    <gallery :label="'Документы'"
                             :root-api-url="attachmentsUrl"
                             :can-update="hasAbilityToUpdateAttachments"
                             :max-files="5"
                             :accepts="documentAccepts"
                             :upload-immediately="true"
                             :max-size="10"
                             :kind="2"
                             :existing="Boolean(objectId)"
                             :delete-on-remove="false"
                             :has-file-name-inputs="true"
                             @files-uploaded="onFilesUploaded($event, 2)"
                             @files-removed="onFilesRemoved($event, 2)"
                             ref="documentGallery"
                             class="col-xs-12 col-sm-12 col-lg-6 m-2">
                    </gallery>

                </b-form-row>


            </div>

            <object-form-buttons :has-changes="hasChanges"
                     :object-exists="Boolean(object.id)"
                     @object-create="onCreateStart"
                     @object-update="onUpdate"
                     @object-cancel-changes="onCancelChanges" class="mb-5"/>


        </b-card>

        <stub v-else :failed-loading="failedLoading"/>

        <confirm-leave-modal ref="leaveDialog" :silent-leave="silentLeave" :leave-browser-confirm="hasChanges"/>

        <b-modal id="add-group" hide-footer hide-header size="md">
            <template #default>
                <question-group-create-modal key="createdGroup"
                                   @object-modal-closed="hideAddGroupModal"
                                   @object-modal-created="onGroupObjectCreated">
                </question-group-create-modal>
            </template>
        </b-modal>

    </div>

</template>

<script>
    import { mapGetters } from 'vuex';
    import api from "@/api";
    import FormField from "@/components/Forms/FormField.vue";
    import { ObjectComponentMixin } from "@/components/Forms/ObjectComponentMixin";
    import ObjectFormButtons from "@/components/Forms/ObjectFormButtons.vue";
    import ConfirmLeaveModal from "@/components/Forms/ConfirmLeaveModal.vue";
    import SingleSelect from "@/components/Select/SingleSelect";
    import ListSelect from "@/components/Select/ListSelect";
    import DataTable from "@/components/Table/DataTable";
    import Stub from "@/components/Stub.vue";
    import Gallery from "@/components/Files/Gallery.vue";
    import {Question} from "@/pages/AppPages/Catalogs/FAQ/question";
    import QuestionGroupCreateModal from "@/pages/AppPages/Catalogs/FAQ/QuestionGroupCreateModal.vue";
    import { VueEditor } from "vue2-editor";

    export default {
        name: "QuestionDetail",
        components: {
            QuestionGroupCreateModal,
            Gallery,
            Stub,
            DataTable,
            ListSelect,
            SingleSelect,
            FormField,
            ObjectFormButtons,
            ConfirmLeaveModal,
            VueEditor
        },
        mixins: [ ObjectComponentMixin ],
        validations() {
            return this.objectClass ? {form: this.objectClass.validations} : {}
        },
        data() {
            return {
                uploadedImageAttachments: [],
                uploadedVideoAttachments: [],
                uploadedDocumentAttachments: [],
                editorToolbar: [
                    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                    ["bold", "italic", "underline", 'link'],
                    [{ 'align': [] }],
                    [{ list: "ordered" }, { list: "bullet" }],
                    [{ 'color': ['#30261D', '#789C4A'] }],
                ],
                resetOnEditorChange: false
            }
        },
        computed: {
            ...mapGetters(['ability', 'isMunicipalController', 'isInContractor', 'isInController',
                'isSuperuser', 'userLastValidContract', 'userLastValidContractObject', 'userValidContractObjectIds', 'userOrganizationMunicipalityNames',
                'userOrganizationId', 'userOrganizationActivities', 'userOrganizationMunicipalities', 'hasMunicipalityRestrictions']),
            groupsUrl() {
                return api.questionGroups.default.list();
            },
            canCreateGroups() {
                return this.isSuperuser || this.isInController
            },
            attachmentsUrl() {
                const questionId = this.objectId
                if (questionId) {
                    const questionUrl = api.questions.default.detail(questionId);
                    return api.questions.attachments.list(questionUrl);
                }
                return api.attachments.default.list()
            },
            photoGalleryAccepts() { return ['image/jpeg', 'image/png', 'image/tiff'] },
            videoGalleryAccepts() { return ['video/mpeg', 'video/mp4'] },
            documentAccepts() { return ['image/jpeg', 'image/tiff', 'application/pdf'] },
            hasAbilityToUpdateAttachments() {
                return this.ability.can('update', 'News') && this.canWork
            },
        },
        methods: {
            showAddGroupModal() {
                this.$bvModal.show('add-group');
            },
            hideAddGroupModal() {
                this.$bvModal.hide('add-group');
            },
            onGroupObjectCreated(newGroup) {
                this.form.group = newGroup['id'];
                this.$v.form.group.$touch();
                this.form.groupObject = newGroup;
                this.hideAddGroupModal();
            },

            onFilesUploaded(uploadedIds, kind) {
                switch (kind) {
                    case 1:
                        this.uploadedImageAttachments = [...this.uploadedImageAttachments, ...uploadedIds.ids]
                        break
                    case 2:
                        this.uploadedDocumentAttachments = [...this.uploadedDocumentAttachments, ...uploadedIds.ids]
                        break
                    case 3:
                        this.uploadedVideoAttachments = [...this.uploadedVideoAttachments, ...uploadedIds.ids]
                        break
                }
                this.$v.form.attachments.$touch();
            },

            onFilesRemoved(idsToExclude, kind) {
                const _filter = (el) => {
                    if (Array.isArray(idsToExclude)) {
                        return idsToExclude.indexOf(el) < 0
                    }
                    return idsToExclude['ids'].indexOf(el) < 0
                }
                this.form.attachments = this.form.attachments.filter(_filter)
                switch (kind) {
                    case 1:
                        this.uploadedImageAttachments = this.uploadedImageAttachments.filter(_filter)
                        break
                    case 2:
                        this.uploadedDocumentAttachments = this.uploadedDocumentAttachments.filter(_filter)
                        break
                    case 3:
                        this.uploadedVideoAttachments = this.uploadedVideoAttachments.filter(_filter)
                        break
                }
                this.$v.form.attachments.$touch();
            },

            onTextChange() {
                if (this.resetOnEditorChange) {
                    this.$v.$reset();
                    this.resetOnEditorChange = false
                }
            },

            onPublishChange() {
                this.$v.form.publish.$touch();
            },

            gatherData() {
                // собрать и объединить данные со всех вложенных форм
                let formData = {}
                formData = Object.assign(formData, this.form);
                formData.attachments = [...this.form.attachments,
                    ...this.uploadedImageAttachments,
                    ...this.uploadedDocumentAttachments,
                    ...this.uploadedVideoAttachments];
                return formData
            },

            async onCreateStart(params) {
                this.create().then(async (routes) => {
                    const route = params.back ? routes.back : routes.next;
                    await this.$router.replace(route);
                });
            },

            async create() {
                const vm = this
                vm.resetOnEditorChange = true
                vm.form = vm.gatherData();
                return new Promise((resolve, reject) => {
                    this.createObject()
                        .then((result) => {
                            vm.uploadedImageAttachments = [];
                            vm.uploadedVideoAttachments = [];
                            vm.uploadedDocumentAttachments = [];
                            resolve(result)
                        }).catch((reason) => {
                            reject(reason)
                        })
                })
            },

            onUpdate() {
                const vm = this
                vm.resetOnEditorChange = true
                vm.form = vm.gatherData();
                return new Promise((resolve, reject) => {
                    vm.updateObject()
                        .then((result) => {
                            vm.uploadedImageAttachments = [];
                            vm.uploadedVideoAttachments = [];
                            vm.uploadedDocumentAttachments = [];
                            resolve(result)
                        }).catch((reason) => {
                            reject(reason)
                        })
                })
            },


            onCancelChanges() {
                this.resetOnEditorChange = true;
                this.$refs.photoGallery.onAttachmentIdsRemoved(this.uploadedImageAttachments)
                this.$refs.documentGallery.onAttachmentIdsRemoved(this.uploadedDocumentAttachments)
                this.$refs.videoGallery.onAttachmentIdsRemoved(this.uploadedVideoAttachments)
                this.onFilesRemoved(this.uploadedImageAttachments, 1)
                this.onFilesRemoved(this.uploadedDocumentAttachments, 2)
                this.onFilesRemoved(this.uploadedVideoAttachments, 3)
                this.cancelChanges();
                this.onUpdate()
            },


        },
        mounted() {
            const vm = this;
            this.onMount();
            this.resetForm().then(() => {
                if (vm.$v.form.$anyDirty) {
                    vm.$v.$reset();
                }
            });
        },
        beforeMount() {
            const vm = this;
            vm.objectClass = Question;
            vm.objectId = vm.$route.params.id;
            vm.apiEntryPoint = api.questions;
            vm.backRoute = 'questionsList';
            vm.nextRoute = 'questionDetail';

            vm.initObjectParams = {};

        }
    }
</script>

<style scoped lang="scss">

</style>